import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=2e2c1bd4&"
import script from "./BlackList.vue?vue&type=script&lang=ts&"
export * from "./BlackList.vue?vue&type=script&lang=ts&"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=2e2c1bd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports